//https://millionaire.cambohow.com
//http://localhost:1338
// export const apiRoot = "http://localhost:1338";
export const apiRoot = "https://millionaire.cambohow.com";